import { useCallback } from "react";
import useApi from "../api";
import { UpsertProcessingRequestLabel } from "./types";

const useProcessingRequestLabelApi = () => {
  const baseurl = "/processing_request_labels";

  const api = useApi();

  const createRequestLabel = useCallback(
    async (l: UpsertProcessingRequestLabel) => {
      const data = await api.post<UpsertProcessingRequestLabel, string>(baseurl, l);
      api.mutateCache([`/processing_requests/${l.requestId}/labels_packagings`]);
      return data;
    },
    [api]
  );

  const updateRequestLabel = useCallback(
    async (l: UpsertProcessingRequestLabel) => {
      const data = await api.put<UpsertProcessingRequestLabel>(baseurl, l);
      api.mutateCache([`/processing_requests/${l.requestId}/labels_packagings`]);
      return data;
    },
    [api]
  );

  const deleteRequestLabel = useCallback(
    async (processingRequestID: number, labelID: string) => {
      const data = await api.del(`${baseurl}/${processingRequestID}?labelID=${labelID}`);
      api.mutateCache([`/processing_requests/${processingRequestID}/labels_packagings`]);
      return data;
    },
    [api]
  );

  return {
    createRequestLabel,
    updateRequestLabel,
    deleteRequestLabel,
  };
};

export default useProcessingRequestLabelApi;
